define([
  "knockout"],
function(ko) {

  "use strict";

  // Usage numericPrice: field
  // If there is a decimal portion, show two decimal places.  If not, show 0 decimal places.
  ko.bindingHandlers.numericPrice = {
    update: function(element, valueAccessor) {
      var value = ko.utils.unwrapObservable(valueAccessor());
      var precision = value % 1 === 0 ? 0 : 2;
      var formattedValue = value.toFixed(precision);
      ko.bindingHandlers.text.update(element, function() {
        return formattedValue;
      });
    },
    defaultPrecision: 1
  };

});
